import React from "react";
import { useLocation } from "react-router-dom";
import ESModuleSubtopic from "../ESModuleSubtopic";

const TimersCountersWatchdogUART = () => {
  const location = useLocation();
  const { subtopics, subjectPath } = location.state || {
    subtopics: [],
    subjectPath: "",
  };

  return (
    <ESModuleSubtopic
      subtopics={subtopics}
      subjectPath={subjectPath}
      title="Timers & Counters, Watchdog Timer, UART, Encoders/decoders"
      videos={[
        "https://www.youtube.com/embed/sfdS36dS4LE",
        "https://www.youtube.com/embed/OTM302B8YRM",
        "https://www.youtube.com/embed/dx1hML0DkN0",
        "https://www.youtube.com/embed/DqCDQH44y9w",
      ]}
      takeaways={[]}
      questions={[
        "1)Design a program to transfer any eight letter word serially at 9600 baud rate, 8 bit data, 1 bit stop and repeat continuously",
        "2)Mention the various use of serial communication. Construct a program using Embedded C/ALP to transfer message “AI-The Devil or Angel” serially with baud rate of 9600 bps using UART protocol.",
        "3) What is watch dog timer? Identify any 5 applications of timers and counters and discuss the working of timers and counters. Write a program for the following? To generate a rectangular waveform of on time 25ms and off time 10mses. Write an 8051 C program to toggle only pin P1.5 continuously every 250msec. Use timer 0, mode2 to create the delay?",
        "4) What is UART? Write a program for 8051 to transfer the data “EXAM” serially at 9600 baud, 8 bit data, and 1 stop bit.",
        "5) Explain the memory interfacing techniques using encoders and decoders",
        "6)What is watch dog timer? Identify any 5 applications of timers and counters and discuss the operation of timers and counters with neat illustration of SFR's and write a program for the following: To generate a rectangular waveform of on time 5ms and off time 15ms and triangular waveform with a delay of 20ms. Assume timer 0, mode 1 with XTAL frequency of 11.059MHZ.",
        "7) Discuss the importance of timers in the 8051 microcontroller and their application in embedded systems and write a code snippet to generate a square wave on PORT 1.0 with a 200ms time period using timer 1 in mode 2 on the 8051 microcontroller users 11.0592 MHz crystal oscillator."
      ]}
      exampleVideos={[]}
    />
  );
};

export default TimersCountersWatchdogUART;
